import teamBiosJson from './teamBios.json';
import { TeamBio, TeamBiosSchema } from '../schemas/teamBio';

export type { TeamBio };
export const TEAM_BIOS: TeamBio[] = TeamBiosSchema.parse(teamBiosJson);
